import { useHMSSyncRoom } from "../hms";
import { useLivekitSyncRoom } from "../livekit";
import { useProviderHook } from "./useProviderHook";

export const useProviderSyncRoom = () =>
  useProviderHook({
    hms: useHMSSyncRoom,
    livekit: useLivekitSyncRoom,
  })();
